/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * The severity level of a single validation problem.
 * @author eric.wittmann@gmail.com
 * @enum
 * @property {ValidationProblemSeverity} ignore
 * @property {ValidationProblemSeverity} low
 * @property {ValidationProblemSeverity} medium
 * @property {ValidationProblemSeverity} high
 * @class
 */
export enum ValidationProblemSeverity {
    ignore, low, medium, high
}


